import React from 'react';
import PropTypes from 'prop-types';
import { HeroSubmitted } from '../../components/Hero';
import { Typography } from '../../components/Typography';
import { CONTACT_SUPPORT_HREF } from '../../constants/text';
import './RegistrationSubmitted.css';

const supportLink = 'D\u2011Wave Support';

const EamilDisplay = ({ labelText, email }) => (
  <div className="submit-complete-email">
    <div>
      <Typography className="bold-label">{labelText}</Typography>
    </div>
    <div>
      <Typography className="registration-submitted registration-submitted--review">{email}</Typography>
    </div>
  </div>
);

EamilDisplay.propTypes = {
  labelText: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
};

export const RegistrationSubmitted = ({ contactEmail, adminEmail, onEditClick }) => (
  <>
    <HeroSubmitted />
    <div className="submit-complete-wrapper">
      <Typography className="registration-submitted">
        {'Registration submitted. A representative from our team will be contacting you within two business days. Please contact '}
        <a href={CONTACT_SUPPORT_HREF}>{supportLink}</a>
        {' through our website if you have any questions.'}
      </Typography>
      <div className="submit-complete-review">
        <Typography className="registration-submitted registration-submitted--review">
          {'Please review below. If either email is incorrect, '}
          <button type="button" onClick={onEditClick}>click here</button>
          {' to edit and resubmit.'}
        </Typography>
        <EamilDisplay email={contactEmail} labelText="Primary Contact Email" />
        <EamilDisplay email={adminEmail} labelText="Project Admin Email" />
      </div>
    </div>
  </>
);

RegistrationSubmitted.propTypes = {
  contactEmail: PropTypes.string.isRequired,
  adminEmail: PropTypes.string.isRequired,
  onEditClick: PropTypes.func.isRequired,
};
